<template>
  <div class="campaigns submit-campaign">
    <div class="inner-content">
      <Alert></Alert>

      <v-form @submit="submitCampaign" v-if="loggedIn">
        <v-text-field
          filled
          name="title"
          v-model="title"
          label="Заглавие"
          type="text"
          v-validate="'required'"
          :error-messages="errors.collect('title')"
        ></v-text-field>

        <v-textarea
          filled
          auto-grow
          label="Описание"
          name="description"
          v-model="description"
          v-validate="'required'"
          :error-messages="errors.collect('description')"
        >
        </v-textarea>

        <v-btn color="primary" class="mt-5 mb-5" :disabled="submitDisabled" @click="submitCampaign" :loading="loading">
          Изпрати <v-icon class="ml-3">send</v-icon>
        </v-btn>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Alert from '@/components/Utils/Alert.vue'

export default {
  name: 'SubmitCampaign',
  components: { Alert },

  data () {
    return {
      title: '',
      description: '',
      submitted: false
    }
  },

  mounted () {
    if (!this.loggedIn) {
      this.$store.commit('showAlert', {
        type: 'error',
        message: 'Само регистрирани потребители могат да предлагат кампании.',
        dismissible: false
      })
    }
  },

  methods: {
    resetForm () {
      this.title = ''
      this.description = ''
      this.$validator.reset()
    },

    submitCampaign () {
      this.$store.commit('setLoading', true)

      this.$store.dispatch('submitCampaign', { title: this.title, description: this.description }).then(() => {
        this.submitted = true
        this.resetForm()
        this.$store.commit('setLoading', false)
        this.$store.commit('showAlert', { type: 'success', message: 'Благодарим Ви за предложението.', dismissible: false })
      }).catch(() => {
        this.$store.commit('setLoading', false)
        this.$store.commit('showAlert', { type: 'error', message: 'Грешка при изпращането на предложението. Моля опитайте отново по-късно.', dismissible: false })
      })
    }
  },

  computed: {
    submitDisabled () {
      return this.title.length === 0 || this.description.length === 0 || this.errors.items.length > 0
    },
    ...mapGetters(['loggedIn', 'loading'])
  },

  beforeRouteLeave (to, from, next) {
    this.$store.commit('clearAlert')
    next()
  }
}
</script>
